// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_JsError from "@rescript/runtime/lib/es6/Stdlib_JsError.js";

let generateRandomString = (function(length) {
    var array = new Uint8Array(length);
    crypto.getRandomValues(array);
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    var result = "";
    for (var i = 0; i < length; i++) {
      result += chars[array[i] % chars.length];
    }
    return result;
  });

let generateCodeChallenge = (async function(verifier) {
    var encoder = new TextEncoder();
    var data = encoder.encode(verifier);
    var hash = await crypto.subtle.digest("SHA-256", data);
    var bytes = new Uint8Array(hash);
    var str = "";
    for (var i = 0; i < bytes.length; i++) {
      str += String.fromCharCode(bytes[i]);
    }
    return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  });

async function startAuth(config) {
  let codeVerifier = generateRandomString(64);
  let codeChallenge = await generateCodeChallenge(codeVerifier);
  let state = generateRandomString(32);
  ((sessionStorage.setItem("pkce_code_verifier", codeVerifier)));
  ((sessionStorage.setItem("pkce_state", state)));
  let params = [
    [
      "client_id",
      config.clientId
    ],
    [
      "redirect_uri",
      config.redirectUri
    ],
    [
      "response_type",
      "code"
    ],
    [
      "code_challenge",
      codeChallenge
    ],
    [
      "code_challenge_method",
      "S256"
    ],
    [
      "state",
      state
    ],
    [
      "scope",
      config.scopes.join(" ")
    ]
  ];
  let queryString = params.map(param => param[0] + `=` + encodeURIComponent(param[1])).join("&");
  return config.authorizeUrl + `?` + queryString;
}

let clearPkceStorage = (function() {
    sessionStorage.removeItem("pkce_code_verifier");
    sessionStorage.removeItem("pkce_state");
  });

async function exchangeCode(config, code) {
  let codeVerifier = (sessionStorage.getItem("pkce_code_verifier") || "");
  if (codeVerifier.length === 0) {
    clearPkceStorage();
    Stdlib_JsError.throwWithMessage("PKCE code verifier not found in session storage");
  }
  let body = [
    [
      "grant_type",
      "authorization_code"
    ],
    [
      "client_id",
      config.clientId
    ],
    [
      "code",
      code
    ],
    [
      "redirect_uri",
      config.redirectUri
    ],
    [
      "code_verifier",
      codeVerifier
    ]
  ].map(param => param[0] + `=` + encodeURIComponent(param[1])).join("&");
  let response = await fetch(config.tokenUrl, {
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    body: body
  });
  let json = await response.json();
  clearPkceStorage();
  let ok = response.ok;
  if (!ok) {
    let status = response.status;
    let errorMsg = json.error;
    Stdlib_JsError.throwWithMessage(`Token exchange failed (` + status.toString() + `): ` + errorMsg);
  }
  let accessToken = json.access_token;
  let tokenType = json.token_type;
  let expiresIn = json.expires_in;
  if (!(accessToken == null) && !(tokenType == null) && !(expiresIn == null)) {
    return {
      accessToken: accessToken,
      tokenType: tokenType,
      expiresIn: expiresIn
    };
  } else {
    return Stdlib_JsError.throwWithMessage("Token response missing required fields (access_token, token_type, expires_in)");
  }
}

async function fetchUserInfo(config, accessToken) {
  let response = await fetch(config.userInfoUrl, {
    method: "GET",
    headers: {
      authorization: `Bearer ` + accessToken
    }
  });
  let json = await response.json();
  let ok = response.ok;
  if (!ok) {
    Stdlib_JsError.throwWithMessage("UserInfo request failed");
  }
  let id = json.id;
  let name = json.name;
  let email = json.email;
  if (!(id == null) && !(name == null) && !(email == null)) {
    return {
      id: id,
      name: name,
      email: email
    };
  } else {
    return Stdlib_JsError.throwWithMessage("UserInfo response missing required fields (id, name, email)");
  }
}

export {
  generateRandomString,
  generateCodeChallenge,
  startAuth,
  clearPkceStorage,
  exchangeCode,
  fetchUserInfo,
}
/* generateCodeChallenge Not a pure module */
